// Saldo pré-pago de disparos (spec precificacao): dinheiro em CENTAVOS inteiros,
// do banco até a tela. Só aqui se converte de e para texto em reais.

const CATEGORIAS = { marketing: 'Marketing', utility: 'Utilidade', authentication: 'Autenticação' };

const TIPOS = {
  recarga: 'Recarga',
  disparo: 'Disparo',
  estorno: 'Estorno',
  ajuste: 'Ajuste',
};

/** 1234 -> "R$ 12,34". Aceita bigint vindo como string do PostgREST. */
export function formatarReais(centavos) {
  const valor = Number(centavos);
  if (!Number.isFinite(valor)) return 'R$ 0,00';
  return (valor / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace(/\u00a0/g, '\u0020');
}

/**
 * "50", "50,5", "1.234,56", "R$ 50,00" -> centavos. Texto que não é dinheiro vira null,
 * nunca zero: uma recarga em branco não pode passar por "R$ 0".
 */
export function reaisParaCentavos(texto) {
  const limpo = String(texto ?? '').replace(/R\$|\s/g, '');
  if (!/^\d{1,3}(\.\d{3})*(,\d{1,2})?$|^\d+(,\d{1,2})?$/.test(limpo)) return null;
  const [inteiro, decimais = ''] = limpo.replace(/\./g, '').split(',');
  return Number(inteiro) * 100 + Number(decimais.padEnd(2, '0'));
}

/** Como o saldo aparece no topo: normal, baixo (abaixo do aviso) ou zerado. */
export function tomDoSaldo(saldoCentavos, avisoCentavos) {
  const saldo = Number(saldoCentavos);
  if (!(saldo > 0)) return 'zerado';
  return saldo < Number(avisoCentavos ?? 0) ? 'baixo' : 'normal';
}

export const CLASSE_DO_TOM = {
  normal: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  baixo: 'bg-amber-50 text-amber-700 border-amber-300',
  zerado: 'bg-red-50 text-red-700 border-red-300',
};

/** Linha do extrato em português: "Disparo · Marketing", "Recarga", "Estorno · Marketing". */
export function rotuloDoLancamento(lancamento) {
  const tipo = TIPOS[lancamento?.tipo] ?? 'Lançamento';
  const categoria = CATEGORIAS[lancamento?.categoria];
  return categoria ? `${tipo} · ${categoria}` : tipo;
}

const ERROS_DO_BANCO = [
  [/recarga_minima/, 'A recarga mínima é de R$ 50,00.'],
  [/sem_permissao/, 'Sem permissão para esta operação.'],
  [/saldo_insuficiente/, 'O saldo não cobre esta operação.'],
  [/ja_estornado/, 'Este lançamento já foi estornado.'],
  [/nao_estorna_estorno/, 'Um estorno não pode ser estornado.'],
  [/motivo_obrigatorio/, 'Informe o motivo.'],
  [/plano_incompativel_com_parceiro/, 'Plano de Parceiro só vale para Parceiro (e Parceiro nunca no Finance).'],
  [/plano_inexistente/, 'Plano inexistente.'],
];

/** A mensagem do Postgres vira texto para o operador; o que não conhecemos aparece como está. */
export function mensagemDoErro(erro) {
  const texto = String(erro?.message ?? erro ?? '');
  const achado = ERROS_DO_BANCO.find(([padrao]) => padrao.test(texto));
  return achado ? achado[1] : `Não foi possível concluir: ${texto}`;
}
